export const COLLECTION_URL: string =
    'https://substrate.office.com/api/v2.0/me/CurrentCollections/';
export const ITEM_URL: string =
    'https://substrate.office.com/api/v2.0/me/currentCollections/{0}/items';
export const ITEM_ID_URL: string =
    'https://substrate.office.com/api/v2.0/me/currentCollections/{0}/items/{1}';
